export enum OSType {
  OTHER, IOS, ANDROID, WINDOWS_PHONE, WINDOWS_OS
};

export enum AppPlatform {
		WEB, MOBILE_WEB, ANDROID, IOS, ANY, WINDOWS_PHONE, WINDOWS_OS
}

export enum Status {
		PASSIVE, ACTIVE
}

export enum IsUseType {
		NOT_USE, USE
}

export enum VisitorType {
		ROLE_VISITOR, ROLE_EMPLOYEE, ROLE_VIP
}

export enum VisitorActionType {
		DEVICE_REGISTOR, DEVICE_POLICY_IN, DEVICE_POLICY_OUT, DEVICE_UNREGISTOR, DEVICE_INTERNAL_IN
}

export enum VisitorComplete {
		VISITING, COMPLETE_VISIT
}

export enum CompanyType {
		TYPE_TO_NORMAL,
		TYPE_TO_VISITOR
}

export enum RoleType {
		ROLE_USER,
		ROLE_ADMIN,
		ROLE_SECURITY_MANAGER,
		ROLE_SUPER_MANAGER,
		ROLE_VISITOR_USER,
		ROLE_VISITOR_ADMIN,
		ROLE_VISITOR_MANAGER
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/model/enumModel.ts